import React from 'react'

interface RoleGuardProps {
	children: React.ReactNode
}

// Pass-through stub. Auth0 was removed from crosure-lite-studio (frontend
// skeleton — all auth lives in Studio). When per-tenant auth is reintroduced,
// the role/route guard will come from @crosure/auth + the tenant's auth
// topology, declared in tenant.bundle.auth.
export const RoleGuard = ({ children }: RoleGuardProps) => <>{children}</>
